import React from "react";
import { Form } from "antd";
import { IIndexTypeCategory } from "../../../indexTypes/model/IndexTypeCategory";
import { TIndexTypeCategoryPresentationModel } from "../../presenter/model/IndexTypeCategoryPresentationModel";
import OrganisationIndexCategoryForm from "./OrganisationIndexCategoryForm";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IStore } from "../../../core/model/runtime/state/Store";
import { TOrganisationIndexCategoryPresentationModel } from "../../presenter/model/OrganisationIndexCategoryPresentationModel";
interface OrganisationIndexCategoryGridProps {
  translate: any;
  organisationIndexCategories: TIndexTypeCategoryPresentationModel[];
  organisationId: number;
  indexTypeCategories: IIndexTypeCategory[];
  createCategory;
  updateOrganisationIndexCategory;
  showDetails;
  indexTypeCategoryId: number;
  createOrganisationCategoryModalVisible: boolean;
  changeCreateCategoryModalVisible: (boolean, number) => void;
  loader;
  store: IStore;
}
const OrganisationIndexCategoryGrid: React.FC<OrganisationIndexCategoryGridProps> =
  ({
    translate,
    organisationIndexCategories,
    organisationId,
    createCategory,
    updateOrganisationIndexCategory,
    showDetails,
    store,
    loader
  }) => {
    const [CreateForm] = Form.useForm();
    const [UpdateForm] = Form.useForm();

    const builder = DataGridConfigurationBuilder({
      translate,
      resourcePrefix: "editors.case_law_document_types"
    });
    const columns = builder.buildColumns(
      {
        name: "name",
        dataKey: "name",

        render: (record: TOrganisationIndexCategoryPresentationModel) => (
          <div> {record.nameTranslation ?? record.name}</div>
        )
      },
      {
        name: "valid",
        dataKey: "valid",
        sortable: false,
        align: "center",
        render: (record) => <TickBox value={record.valid} />
      },
      {
        name: "typeDetails",
        dataKey: "typeDetails",
        sortable: false,
        align: "center",
        render: (record) => (
          <button
            type="button"
            className="ant-btn ant-btn-link ant-btn-sm"
            onClick={() => showDetails(record.id)}
          >
            <span>{translate("editors.case_law_document_types.details")}</span>
          </button>
        )
      }
    );

    return (
      <div>
        {organisationIndexCategories?.map((category) => (
          <div style={{ marginBottom: 20 }} key={`category-${category?.id}`}>
            <DataGrid
              title={category?.name}
              columns={columns}
              translate={translate}
              keyProperty="id"
              dataSource={category?.organisationCategories || []}
              allowCreate={true}
              allowUpdate={true}
              addButtonText={"Novi zapis"}
              createForm={
                <OrganisationIndexCategoryForm
                  translate={translate}
                  form={CreateForm}
                  indexTypeCategoryId={category.id}
                  organisationId={organisationId}
                  store={store}
                />
              }
              updateForm={
                <OrganisationIndexCategoryForm
                  translate={translate}
                  form={UpdateForm}
                  indexTypeCategoryId={category.id}
                  organisationId={organisationId}
                  store={store}
                />
              }
              createModalTitle={"Novi zapis"}
              updateModalTitle={"Novi zapis"}
              loading={loader}
              onCreate={createCategory}
              onUpdate={updateOrganisationIndexCategory}
              booleanColumnKeys={["valid"]}
              createModalClass={"modal-width"}
              updateModalClass={"modal-width"}
              CreateFormInstance={CreateForm}
              UpdateFormInstance={UpdateForm}
              createActionPosition={"topRight"}
            />
          </div>
        ))}
      </div>
    );
  };
export default OrganisationIndexCategoryGrid;
